import { useCallback, useMemo, useState } from "react";
import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import SearchResults from "@/pages/home/components/SearchResults";
import QuickEntry from "@/pages/home/components/QuickEntry";
import PopularSection from "@/pages/home/components/PopularSection";
import CategorySection from "@/pages/home/components/CategorySection";
import LatestSection from "@/pages/home/components/LatestSection";
import FaqSection from "@/pages/home/components/FaqSection";
import AboutSection from "@/pages/home/components/AboutSection";
import SiteFooter from "@/pages/home/components/SiteFooter";
import BackToTop from "@/pages/home/components/BackToTop";
import { contentItems, heroKeywords, heroStats } from "@/mocks/portal";

export default function Home() {
  const [query, setQuery] = useState("");
  const [submittedQuery, setSubmittedQuery] = useState("");
  const [activeCategory, setActiveCategory] = useState("全部");

  const searchResults = useMemo(() => {
    const keyword = submittedQuery.trim().toLowerCase();
    if (!keyword) return [];
    return contentItems.filter((item) => {
      const haystack = `${item.title} ${item.excerpt} ${item.category} ${item.tag}`.toLowerCase();
      return haystack.includes(keyword);
    });
  }, [submittedQuery]);

  const runSearch = useCallback((value: string) => {
    const keyword = value.trim();
    setSubmittedQuery(keyword);
    setQuery(keyword);
    if (keyword) {
      window.setTimeout(() => {
        document.getElementById("search-results")?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
    }
  }, []);

  const clearSearch = useCallback(() => {
    setSubmittedQuery("");
    setQuery("");
  }, []);

  const selectCategory = useCallback((category: string) => {
    setActiveCategory(category);
    setSubmittedQuery("");
    setQuery("");
    window.setTimeout(() => {
      document.getElementById("category")?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 60);
  }, []);

  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main className="w-full">
        <Hero
          query={query}
          onQueryChange={setQuery}
          onSubmit={runSearch}
          onKeywordClick={runSearch}
          keywords={heroKeywords}
          stats={heroStats}
        />
        {submittedQuery.trim() && (
          <SearchResults
            query={submittedQuery}
            items={searchResults}
            onClear={clearSearch}
            onCategorySelect={selectCategory}
          />
        )}
        <QuickEntry onSelectCategory={selectCategory} />
        <PopularSection />
        <CategorySection activeCategory={activeCategory} onCategoryChange={selectCategory} />
        <LatestSection />
        <FaqSection />
        <AboutSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}